import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import useFetchList from "../../utils/useFetchLIst";
import DispatchedForm from "./DispatchedForm";
import { loaderOverlay } from "../../Style/loaderOverly";
import { LoaderCreatePage } from "../Loader/Loader";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput";

// "Select All" is a synthetic option, it never reaches the API.
const SELECT_ALL = -1;

const DispatchedCreate = () => {
  const [selectedJobCards, setSelectedJobCards] = useState([]);
  const [errors, setErrors] = useState({});
  const [jobCardsOptions, setJobCardsOptions] = useState([]);
  const [showDispatchForm, setShowDispatchForm] = useState(false);
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "job_cards",
    schema: schema,
    whereCondition: {
      is_active: true,
      status: "Repair Completed",
    },
    orderBy: {
      field: "job_card_no",
      order: "asc",
    },
    include: [
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
    ],
  };

  const { data: jobCardData, loading } = useFetchList("/getRecords", payload);

  // Full job card rows for whatever is currently selected, in the order the
  // dropdown lists them so the review table stays stable.
  const selectedJobCardData = useMemo(() => {
    const selectedIds = new Set(selectedJobCards.map((item) => item.value));
    return (jobCardData || []).filter((item) => selectedIds.has(item.id));
  }, [jobCardData, selectedJobCards]);

  useEffect(() => {
    if (jobCardData) {
      const options = jobCardData.map((job) => ({
        value: job.id,
        label: job.intake?.material_serial_no || job.job_card_no,
      }));

      setJobCardsOptions(
        options.length ? [{ value: SELECT_ALL, label: "Select All" }, ...options] : []
      );
    }
  }, [jobCardData]);

  const handleChange = (selectedOptions) => {
    const value = selectedOptions || [];
    const actualOptions = jobCardsOptions.filter(
      (opt) => opt.value !== SELECT_ALL
    );

    // "Select All" expands to every option so the rest of the page only ever
    // deals with real job card ids.
    const isSelectAll = value.some((item) => item.value === SELECT_ALL);

    setSelectedJobCards(isSelectAll ? actualOptions : value);
    setErrors({ job_card_no: value.length ? "" : "Serial Number cannot be blank." });
    setShowDispatchForm(false);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!selectedJobCards.length) {
      setErrors({ job_card_no: "Serial Number cannot be blank." });
      return;
    }

    setErrors({});
    setShowDispatchForm(true);
  };

  const handleRemoveJobCard = (jobCardId) => {
    const remaining = selectedJobCards.filter(
      (item) => item.value !== jobCardId
    );

    setSelectedJobCards(remaining);

    if (!remaining.length) {
      setShowDispatchForm(false);
      setErrors({ job_card_no: "Serial Number cannot be blank." });
    }
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"Dispatch Job Card"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <MultiSelectInput
                      label="Serial Number"
                      options={jobCardsOptions}
                      value={selectedJobCards}
                      onMultiSelect={handleChange}
                      placeholder="Select Serial Number"
                      labelClassName="form-label custom-label"
                      selectClassName="font-size-13"
                      isClearable={true}
                      asterisk={true}
                      noDataMessage="No job card is ready for dispatch"
                      customError={errors.job_card_no}
                    />
                  </div>
                </div>
                <div className="col-6 mt-3 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: "80px",
                      fontSize: "13px",
                    }}
                  >
                    GO{" "}
                  </button>
                </div>
              </div>
            </form>
          </div>
          {loading && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
        {showDispatchForm && selectedJobCardData.length > 0 && (
          <DispatchedForm
            jobCards={selectedJobCardData}
            onRemoveJobCard={handleRemoveJobCard}
          />
        )}
      </div>
    </>
  );
};

export default DispatchedCreate;
